import iaReducer from './iaSlice';
export default iaReducer;
export { iaReducer };
export * from './iaSlice';
export * from './iaSelectors';
